import { Loader2 } from 'lucide-react'

import { cn } from '@/lib/utils'

const spinnerSizes = {
  sm: 'size-4',
  md: 'size-6',
  lg: 'size-8',
} as const

export interface SpinnerProps {
  size?: keyof typeof spinnerSizes
  label?: string
  className?: string
}

function Spinner({ size = 'md', label, className }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label={label ?? 'Loading'}
      className={cn('inline-flex items-center gap-2', className)}
    >
      <Loader2 aria-hidden className={cn('animate-spin text-primary', spinnerSizes[size])} />
      {label ? <span className="text-sm text-muted-foreground">{label}</span> : null}
    </span>
  )
}

export { Spinner }